import { asyncToGenerator as _asyncToGenerator } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { getPreferenceSourceOptions, getPreferenceModuleOptions, getPreferenceSource } from './config.js';
import { PreferenceSource } from './constants.js';
import { getPreferenceState } from './selectors.js';

var UPDATE_PREFERENCE = "PREFERENCES/UPDATE";
var RESET_PREFERENCES = "PREFERENCES/RESET";
var LOAD_PREFERENCES = "PREFERENCES/LOAD";
/**
 * Action creator for updating a single preference value
 * @param {string} key Preference key to update
 * @param {*} value New preference value
 */

var updatePreference = function updatePreference(key, value) {
  return {
    type: UPDATE_PREFERENCE,
    key: key,
    value: value
  };
};
/**
 * Action creator for resetting all preferences to default values
 */


var resetPreferences = function resetPreferences() {
  return {
    type: RESET_PREFERENCES
  };
};
/**
 * Action creator to load preferences from previously saved data (if configured)
 * @param {function} onLoadSuccess Callback function which receives the newly loaded preferences when loading was successful
 * @returns {boolean} Whether loading was successful
 */


var loadPreferences = function loadPreferences(onLoadSuccess) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var source, options, provider, value, data, _options, _yield$dispatch, success, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              source = getPreferenceSource();
              _context.t0 = source;
              _context.next = _context.t0 === PreferenceSource.DeviceStorage ? 4 : _context.t0 === PreferenceSource.Api ? 18 : 29;
              break;

            case 4:
              options = getPreferenceSourceOptions();
              provider = getPreferenceModuleOptions().preferenceStoreProvider;

              if (!(provider == null)) {
                _context.next = 9;
                break;
              }

              console.error("No preference provider configured");
              return _context.abrupt("return", false);

            case 9:
              _context.next = 11;
              return provider.getPreference(options.key);

            case 11:
              value = _context.sent;

              if (!value) {
                _context.next = 17;
                break;
              }

              data = JSON.parse(value);
              dispatch({
                type: LOAD_PREFERENCES,
                values: data
              });
              onLoadSuccess && onLoadSuccess(data);
              return _context.abrupt("return", true);

            case 17:
              return _context.abrupt("return", false);

            case 18:
              _options = getPreferenceSourceOptions();
              _context.next = 21;
              return dispatch(typeof _options.loadAction === "function" ? _options.loadAction() : _options.loadAction);

            case 21:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              response = _yield$dispatch.response;

              if (!(success && response)) {
                _context.next = 28;
                break;
              }

              dispatch({
                type: LOAD_PREFERENCES,
                values: response
              });
              onLoadSuccess && onLoadSuccess(response);
              return _context.abrupt("return", true);

            case 28:
              return _context.abrupt("return", false);

            case 29:
              console.error("loadPreferences not supported by the current preference source");
              return _context.abrupt("return", false);

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * Action creator to save preferences for re-loading later (if configured)
 */


var savePreferences = function savePreferences() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var source, state, options, provider, _options2, _yield$dispatch2, success;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              source = getPreferenceSource();
              state = getPreferenceState(getState());
              _context2.t0 = source;
              _context2.next = _context2.t0 === PreferenceSource.DeviceStorage ? 5 : _context2.t0 === PreferenceSource.Api ? 13 : 19;
              break;

            case 5:
              options = getPreferenceSourceOptions();
              provider = getPreferenceModuleOptions().preferenceStoreProvider;

              if (!(provider == null)) {
                _context2.next = 10;
                break;
              }

              console.error("No preference provider configured");
              return _context2.abrupt("return", false);

            case 10:
              _context2.next = 12;
              return provider.setPreference(options.key, JSON.stringify(state));

            case 12:
              return _context2.abrupt("return", true);

            case 13:
              _options2 = getPreferenceSourceOptions();
              _context2.next = 16;
              return dispatch(_options2.saveAction(state));

            case 16:
              _yield$dispatch2 = _context2.sent;
              success = _yield$dispatch2.success;
              return _context2.abrupt("return", success);

            case 19:
              console.error("savePreferences not supported by the current preference source");
              return _context2.abrupt("return", false);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

export { LOAD_PREFERENCES, RESET_PREFERENCES, UPDATE_PREFERENCE, loadPreferences, resetPreferences, savePreferences, updatePreference };
